/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';

import { BrandColors, Header } from '@blend/enterprise-components';

export const styles = StyleSheet.create({
  underline: {
    backgroundColor: BrandColors.SKY,
    height: 4,
    marginBottom: 32,
    marginTop: 8,
    width: 40,
  },
});

export namespace SectionHeader {
  export interface Props {
    text: string;
  }
}

export const SectionHeader: React.FC<SectionHeader.Props> = ({ text }) => {
  return (
    <div>
      <Header size={2}>{text}</Header>
      <div className={css(styles.underline)} />
    </div>
  );
};
